import { cachedRequestByIdReducer } from './helpers';
import { values } from 'lodash';

import { cloudAcquisitionActionTypes } from './../actions/types';

const cloudAcquisitions = cachedRequestByIdReducer(cloudAcquisitionActionTypes);
export default cloudAcquisitions;

export const getCloudAcquisitions = (state) => {
  return values(state.cloudAcquisitions.byId);
};

export const getCloudPlatforms = (state) => {
  function distinct(value, index, self) {
    return self.indexOf(value) === index;
  }

  return getCloudAcquisitions(state)
    .map(a => a.platform)
    .filter(distinct);
};


// WEBPACK FOOTER //
// src/reducers/cloudAcquisitions.js